import { render, staticRenderFns } from "./estoquedeMedicamentosPorRegiaoEFarmacia.vue?vue&type=template&id=6304fd97&scoped=true&"
import script from "./estoquedeMedicamentosPorRegiaoEFarmacia.vue?vue&type=script&lang=js&"
export * from "./estoquedeMedicamentosPorRegiaoEFarmacia.vue?vue&type=script&lang=js&"
import style0 from "./estoquedeMedicamentosPorRegiaoEFarmacia.vue?vue&type=style&index=0&id=6304fd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304fd97",
  null
  
)

export default component.exports